module.exports = __webpack_public_path__ + "img/productos.470cfd8d.jpeg";